import React from "react";
import Draggable from "react-draggable";
import { thousandsSeparators } from "../../../config/utils";

export const SiteBuildingInfoModal = ({ onCancel, basicDetails, infoType, siteBuildingData }) => {
    return (
        <React.Fragment>
            <div
                className="modal modal-region rst-pwd modal-loc-detail"
                style={{ display: "block" }}
                id="modalId"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <Draggable handle=".draggable" cancel=".not-draggable">
                    <div className="modal-dialog " role="document">
                        <div className="modal-content">
                            <div className="modal-header draggable">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    {infoType === "site"
                                        ? "Site Details"
                                        : infoType === "building"
                                        ? "Building Details"
                                        : ` ${infoType} Details` || ""}
                                </h5>
                                <button
                                    type="button"
                                    className="close not-draggable"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={onCancel && onCancel}
                                >
                                    <span aria-hidden="true">
                                        <img src="/img/close.svg" alt="" />
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body region-otr build-type-mod">
                                <div className={`map-detail-cover-outer ${infoType === "Status" ? "" : "bg-white"}`}>
                                    {infoType === "Status" ? (
                                        Array.isArray(basicDetails) ? (
                                            <>
                                                {basicDetails
                                                    .filter(item => item.options)
                                                    .map((item, index) => (
                                                        <ul className="sub-cord-outer">
                                                            <li key={index} className="sub-cord-txt ml-2">
                                                                <div className="loc-icon-name">{item.label || "-"}</div>
                                                                <ul>
                                                                    {item.options.map((option, idx) => (
                                                                        <ul className="sub-cord">
                                                                            <li key={idx}>
                                                                                <span className="label-name">{option.label}:</span>
                                                                                <span className="label-dtl"> {option.description || "-"}</span>
                                                                            </li>
                                                                        </ul>
                                                                    ))}
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    ))}
                                            </>
                                        ) : (
                                            <ul className="sub-cord">
                                                <li className="sub-cord-txt ml-2">
                                                    <span className="label-name">{basicDetails || "-"}:</span>
                                                    <span className="label-dtl"> {basicDetails || "-"}</span>
                                                </li>
                                            </ul>
                                        )
                                    ) : (
                                        <>
                                            <ul className="sub-cord">
                                                <li className="sub-cord-txt">
                                                    <span className="label-name">
                                                        {infoType === "site" ? "Region:" : infoType === "building" ? "Type:" : "-"}
                                                    </span>
                                                    <span className="label-dtl">
                                                        {" "}
                                                        {infoType === "site"
                                                            ? basicDetails?.region || "-"
                                                            : infoType === "building"
                                                            ? basicDetails?.building_type || "-"
                                                            : "-"}
                                                    </span>
                                                </li>
                                                {infoType === "building" && (
                                                    <li className="sub-cord-txt ml-2">
                                                        <span className="label-name">Site:</span>
                                                        <span className="label-dtl"> {basicDetails?.site || "-"}</span>
                                                    </li>
                                                )}
                                            </ul>
                                            <span className="loc-current-name">
                                                <i className="fas fa-map-marker-alt"></i> {basicDetails?.place || "N/A"}
                                            </span>
                                            <br />
                                            <ul>
                                                <li>
                                                    <span className="label-name">FCI:</span>{" "}
                                                    <span className="label-detl">{basicDetails?.fci?.toFixed(2) || "-"}</span>
                                                </li>
                                                <li>
                                                    <span className="label-name">EFCI:</span>{" "}
                                                    <span className="label-detl">{basicDetails?.efci?.toFixed(2) || "-"}</span>
                                                </li>
                                                <li>
                                                    <span className="label-name">DM:</span>{" "}
                                                    <span className="label-detl">
                                                        {basicDetails?.dm != null ? `$ ${(basicDetails?.dm / 1000000).toFixed(2)}M` : "-"}
                                                    </span>
                                                </li>
                                                <li>
                                                    <span className="label-name">FC:</span>{" "}
                                                    <span className="label-detl">
                                                        {basicDetails?.future_capital != null
                                                            ? `$ ${(basicDetails?.future_capital / 1000000).toFixed(2)}M`
                                                            : "-"}
                                                    </span>
                                                </li>
                                                <li>
                                                    <span className="label-name">CSP:</span>{" "}
                                                    <span className="label-detl">
                                                        {" "}
                                                        {basicDetails?.csp != null ? `$ ${(basicDetails?.csp / 1000000).toFixed(2)}M` : "-"}
                                                    </span>
                                                </li>
                                                <li>
                                                    <span className="label-name">SF:</span>{" "}
                                                    <span className="label-detl">
                                                        {basicDetails?.square_foot_area ? thousandsSeparators(basicDetails?.square_foot_area) : "-"}
                                                    </span>
                                                </li>
                                                <li>
                                                    <span className="label-name">CRV:</span>{" "}
                                                    <span className="label-detl">
                                                        {" "}
                                                        {basicDetails?.crv != null ? `$ ${(basicDetails.crv / 1000000).toFixed(2)}M` : "-"}
                                                    </span>
                                                </li>
                                            </ul>
                                            _
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </Draggable>
            </div>
        </React.Fragment>
    );
};
